import { Link, Navigate, Outlet } from 'react-router';
import { useAuthStore } from '@/services/store/use-auth-store.tsx';
import HeroImage from '@tenant/hero.webp';
import { useTranslation } from 'react-i18next';
import { SelectLanguage } from '@/components/select-language.tsx';

const loader = document.querySelector('.loader-container')!;
const hideLoader = () => {
  loader.classList.add('loader--hide');
};

export function Authentication() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { t } = useTranslation();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  hideLoader();

  return (
    <div className="relative min-h-[100svh]">
      <div className="absolute top-6 right-6 z-50">
        <SelectLanguage />
      </div>
      <div className="flex min-h-[100svh] flex-col items-center justify-between px-4">
        <div className="flex h-full w-full flex-1 items-center justify-center py-4">
          <div className="w-full max-w-[450px] rounded-lg bg-white px-8 py-10 shadow-2xl">
            <Outlet />
          </div>
        </div>
        <div className="pb-4 text-center text-sm">
          <div className="flex items-center space-x-2 text-white">
            <Link to="/" className="link-underline text-white">
              {t('auth.footer.privacyPolicy')}
            </Link>
            <span>|</span>
            <Link to="/" className="link-underline text-white">
              {t('auth.footer.termsOfUse')}
            </Link>
            <span>|</span>
            <Link to="/" className="link-underline text-white">
              {t('auth.footer.cookiesPolicy')}
            </Link>
          </div>
        </div>
      </div>
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HeroImage})` }}
      />
    </div>
  );
}

export default Authentication;
